/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/search/search.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { NgModule } from "@angular/core";
import { SearchRoutingModule } from "./search-routing.module";
import * as i0 from "@angular/core";
export class SearchModule {
    constructor() {
    }
}
SearchModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    SearchRoutingModule,
                ],
            },] },
];
/** @nocollapse */
SearchModule.ctorParameters = () => [];
/** @nocollapse */ SearchModule.ɵmod = i0.ɵɵdefineNgModule({ type: SearchModule });
/** @nocollapse */ SearchModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SearchModule_Factory(t) { return new (t || SearchModule)(); }, imports: [[
            SearchRoutingModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SearchModule, { imports: [SearchRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SearchModule, [{
        type: NgModule,
        args: [{
                imports: [
                    SearchRoutingModule,
                ],
            }]
    }], function () { return []; }, null); })();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoLm1vZHVsZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uLy4uLy4uL3Zpc2lvbmljcy9uZy9zcmMvYXBwL3NlYXJjaC9zZWFyY2gubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGVBQWUsQ0FBQztBQUN2QyxPQUFPLEVBQUMsbUJBQW1CLEVBQUMsTUFBTSx5QkFBeUIsQ0FBQzs7QUFPNUQsTUFBTSxPQUFPLFlBQVk7SUFDdkI7SUFBZSxDQUFDOzs7WUFOakIsUUFBUSxTQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixtQkFBbUI7aUJBQ3BCO2FBQ0Y7Ozs7Z0RBQ1ksWUFBWTt1R0FBWixZQUFZLGtCQUpiO1lBQ1IsbUJBQW1CO1NBQ3BCO3dGQUVVLFlBQVksY0FIckIsbUJBQW1CO2tEQUdWLFlBQVk7Y0FMeEIsUUFBUTtlQUFDO2dCQUNSLE9BQU8sRUFBRztvQkFDUixtQkFBbUI7aUJBQ3BCO2FBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge05nTW9kdWxlfSBmcm9tIFwiQGFuZ3VsYXIvY29yZVwiO1xuaW1wb3J0IHtTZWFyY2hSb3V0aW5nTW9kdWxlfSBmcm9tIFwiLi9zZWFyY2gtcm91dGluZy5tb2R1bGVcIjtcblxuQE5nTW9kdWxlKHtcbiAgaW1wb3J0cyA6IFtcbiAgICBTZWFyY2hSb3V0aW5nTW9kdWxlLFxuICBdLFxufSlcbmV4cG9ydCBjbGFzcyBTZWFyY2hNb2R1bGUge1xuICBjb25zdHJ1Y3RvcigpIHt9XG59XG4iXX0=